export const PROVIDERS_PER_PAGE = 25;

export const INITIAL_PROVIDER_FORM = {
  uuid: null,
  legal_business_name: '',
  company: '',
  cuit: '',
  libb: '',
  phone_number: '',
  email: '',
  contact_information: '',
  address: '',
  postal_code: '',
  uuid_province: '',
  uuid_department: '',
  uuid_district: '',
  observations: '',
};

export const PROVIDER_TEXTS = {
  title: 'Stock y compras | Proveedores',
  info:
    'Proveedores de materiales: los que aparecen al armar y emitir órdenes a proveedor. ' +
    'Quitar uno solo lo saca de esta lista (no lo borra); en Finanzas sigue igual. ' +
    'Las marcas de cada entidad se editan en Entidades | Personas Jurídicas.',
  add: 'Nuevo proveedor',
  search: 'Buscar proveedor',
  legalBusinessName: 'Razón social',
  company: 'Nombre de fantasía',
  cuit: 'CUIT',
  libb: 'Ingresos brutos',
  phone: 'Teléfono',
  email: 'Email',
  contact: 'Persona de contacto',
  address: 'Dirección',
  postalCode: 'Código postal',
  province: 'Provincia',
  department: 'Departamento',
  district: 'Localidad',
  observations: 'Observaciones',
  actions: 'Acciones',
  edit: 'Editar',
  remove: 'Quitar de proveedores',
  empty: 'No hay proveedores para esta búsqueda.',
  loadError: 'No se pudieron cargar los proveedores.',
  retry: 'Reintentar',
  createTitle: 'Nuevo proveedor',
  editTitle: 'Editar proveedor',
  generalSection: 'Datos del proveedor',
  contactSection: 'Contacto',
  addressSection: 'Dirección',
  notesSection: 'Observaciones',
  save: 'Guardar',
  cancel: 'Cancelar',
  saveError: 'No se pudo guardar el proveedor.',
  removeError: 'No se pudo quitar el proveedor.',
  summary: 'Proveedor',
  confirmTitle: 'Quitar de proveedores',
  confirmText: 'Quitar',
  confirmMessage: (provider) =>
    `¿Quitás a "${provider?.legal_business_name || provider?.company || ''}" ` +
    'de los proveedores de materiales? No se borra: deja de aparecer en Stock y compras, ' +
    'en Finanzas sigue igual y se puede volver a marcar desde Entidades | Personas Jurídicas.',
  required: 'Campo obligatorio',
  invalidCuit: 'El CUIT debe tener 11 dígitos',
  invalidEmail: 'Email inválido',
  searchPlaceholder: 'Buscar',
};
